<template>
  <div
    class="mobgivef-right-overflow-2 mobpx0 givef-right-overflow-2 px-4 py-3"
  >
    <div
      v-for="(field, index) in normalFields"
      :key="index"
      :class="index === 0 ? 'mt-0' : 'mt-3'"
    >
      <div class="newInt-rs-head">{{ field.label }}</div>

      <div v-if="checkFieldKeys(field)">-</div>
      <div
        class="newInt-rs-subhead"
        style="word-break: keep-all"
        v-else-if="Object.keys(selectedJD).length > 0"
      >
        <template v-if="isHtmlContent(field)">
          <div v-html="checkValuesOfKey(field)"></div>
        </template>
        <template v-else>
          {{ checkValuesOfKey(field) }}
        </template>
      </div>
    </div>
    <div class="mt-3" v-if="advancedFields.length != 0">
      <div
        class="d-flex align-items-center pointer"
        @click="showAdvanced = !showAdvanced"
      >
        <img
          v-if="!showAdvanced"
          src="../../assets/img/newworkbench/internalhiring/advance.svg"
          alt=""
        />
        <img
          v-else
          src="../../assets/img/newworkbench/internalhiring/advanceUp.svg"
          alt=""
        />
        <span class="ihd-advance-text ml-2 mr-2">Advanced</span>
        <hr />
      </div>
    </div>
    <template v-if="showAdvanced">
      <div
        class="mt-3"
        v-for="(field, index) in advancedFields"
        :key="index + 'adv'"
      >
        <div class="newInt-rs-head">{{ field.label }}</div>

        <div v-if="checkFieldKeys(field)">-</div>
        <div
          class="newInt-rs-subhead"
          style="word-break: keep-all"
          v-else-if="Object.keys(selectedJD).length > 0"
        >
          <template v-if="isHtmlContent(field)">
            <div v-html="checkValuesOfKey(field)"></div>
          </template>
          <template v-else>
            {{ checkValuesOfKey(field) }}
          </template>
        </div>
        <div
          v-if="!checkFieldKeys(field) && field.controlType == 'upload_file'"
          class="pointer"
        >
          <img
            @click="downloadFile(field)"
            class="ml-2"
            src="../../assets/talentpool/tp_download_vc.svg"
            alt=""
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  checkFieldKeys,
  isHtmlContent,
  checkValuesOfKey,
} from "../../utils/customFields";
export default {
  name: "JobDetail",
  props: {
    normalFields: Array,
    advancedFields: Array,
    selectedJD: Object,
  },
  data() {
    return {
      showAdvanced: false,
    };
  },
  methods: {
    checkFieldKeys(field) {
      return checkFieldKeys(field, this.selectedJD);
    },
    isHtmlContent(field) {
      return isHtmlContent(field, this.selectedJD);
    },
    checkValuesOfKey(field) {
      return checkValuesOfKey(field, this.selectedJD);
    },
  },
};
</script>
<style>
@media (max-width: 1028px) {
  .mobgivef-right-overflow-2 {
    height: calc(100vh - 135px) !important;
  }
  .mobpx0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .newInt-rs-head {
    font-size: 12px;
  }
  .newInt-rs-subhead {
    font-size: 13px;
  }
}
</style>
